import React, { useContext } from 'react';
import Link from 'next/link';
import OutsideClickHandler from 'react-outside-click-handler';

import { HeaderContext } from '../HeaderContext';

import { track } from '../../../services/analytics';

import { Burger } from '../../Burger/Burger';
import { DropDown } from '../../DropDown/DropDown';
import { MainMenu } from '../MainMenu/MainMenu';
import { Basket, Gift, Wallet } from '../../Icons';
import { Button, SrOnly } from '@husslehq/ui-library';

import styles from './HeaderActions.module.scss';

export type HeaderActionsProps = {
  walletAction?: () => void;
  basketCount: number;
  basketAmount?: string;
  showGift: boolean;
};

export const HeaderActions: React.FC<HeaderActionsProps> = ({ basketCount, walletAction, showGift }) => {
  const { isAuthenticated, isMobileView, register, login, isDropDownOpen, toggleDropDown, walletAmount } =
    useContext(HeaderContext);

  const trackMenu = (label: string) => {
    track({
      event: 'gym_spa',
      category: 'OnClick',
      action: 'Gym Page',
      label: label,
    });
  };

  return (
    <div className={styles['header-actions']}>
      {showGift && (
        <Link href="/gifturl">
          <a className={styles['header-actions__icon']}>
            <SrOnly>You have a gift!</SrOnly>
            <Gift />
          </a>
        </Link>
      )}
      {isAuthenticated && isMobileView && walletAmount > 0 && (
        <Button
          level="link"
          className={`${styles['header-actions__icon']} ${styles['header-actions__icon--wallet']}`}
          onClick={walletAction}
        >
          <SrOnly>Your wallet</SrOnly>
          <Wallet />
        </Button>
      )}
      {basketCount > 0 && (
        <Link href="/checkout" prefetch={false}>
          <a className={`${styles['header-actions__icon']} ${styles['header-actions__icon--checkout']}`}>
            <SrOnly>Checkout</SrOnly>
            <Basket />
            {/*<span className={styles['header-actions__icon-count']}>{basketCount}</span>*/}
          </a>
        </Link>
      )}
      {!isAuthenticated ? (
        <>
          {!isMobileView && (
            <>
              <Button className={styles['header-actions__btn']} level="outline" onClick={login}>
                Log In
              </Button>
              <Button
                className={styles['header-actions__btn']}
                level="outline"
                onClick={() => {
                  trackMenu('Register here Button');
                  register();
                }}
              >
                Register
              </Button>
            </>
          )}
        </>
      ) : (
        !isMobileView && (
          <OutsideClickHandler disabled={!isDropDownOpen} onOutsideClick={toggleDropDown}>
            <Button
              className={styles['header-actions__btn']}
              level="outline"
              onClick={() => {
                trackMenu('Menu button');
                toggleDropDown();
              }}
            >
              Menu
            </Button>
            {isDropDownOpen && (
              <DropDown
                variant={isAuthenticated ? 'loggedin' : undefined}
                isOpen={isDropDownOpen}
                shouldSlideDown={isMobileView}
              >
                <MainMenu />
              </DropDown>
            )}
          </OutsideClickHandler>
        )
      )}
      {isMobileView && (
        <Burger
          onClick={() => {
            trackMenu('Menu button');
            toggleDropDown();
          }}
        />
      )}
    </div>
  );
};
